import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import recommendationBoxStyle from "@/src/components/Form/RecommendationBoxStyle";

type RecommendationBoxProps = {
  children: ReactNode;
};

export default function RecommendationBox({ children }: RecommendationBoxProps) {
  return (
    <Grid size={12}>
      <Box sx={recommendationBoxStyle}>{children}</Box>
    </Grid>
  );
}
